export default __webpack_public_path__ + "static/media/TabletFingerprints.ac720919.png";